// extracted by mini-css-extract-plugin
export default {"skill_card":"SkillCard_skill_card__jCHeW","logo_box":"SkillCard_logo_box__aQl04","logo":"SkillCard_logo__apPC6","content_box":"SkillCard_content_box__9Jzqi"};